import { Component, Renderer2, ChangeDetectorRef } from '@angular/core';
import { appState } from '@services/app-state';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '@environments/environment';
import { RestApiService, AuthService, VznFeathersService } from '@noammazuz/vzn-feathers';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppStateService } from '@servicesapp-state.service';
import { filter } from 'rxjs/operators';
import { ServiceMethods } from '@feathersjs/feathers';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'all-around-player-client';
  appState = appState;
  mobileQuery: MediaQueryList;
  fullScreen: boolean;
  showLanguageSelection: boolean = false;
  lang = 'en';
  private _mobileQueryListener: () => void;
  actionService: ServiceMethods<any>;

  constructor(
    public router: Router,
    private restApiService: RestApiService<any>,
    media: MediaMatcher,
    public translate: TranslateService,
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef,
    private appStateService: AppStateService,
    private authService: AuthService<any>,
    private feathers: VznFeathersService<any>,
  ) {
    (window as any).appState = appState;
    this.translate = translate;
    this.actionService = this.feathers.service('actions');

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      if (e.url.indexOf('login') > -1) {
        this.showLanguageSelection = true;
      }
      if (e.url.indexOf('log-table') !== -1 ||
          e.url.indexOf('email-table') !== -1 ||
          e.url.indexOf('email-details') !== -1 ||
          e.url.indexOf('mail-list-table') !== -1 ||
          e.url.indexOf('mail-list-details') !== -1 ||
          e.url.indexOf('sites') !== -1 ||
          e.url.indexOf('site-details') !== -1) {
        this.fullScreen = false;
      } else {
        this.fullScreen = true;
        console.log('full screen');
      }
    });

    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    translate.addLangs(['en', 'he']);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|he/) ? browserLang : 'he');

    translate.onLangChange.subscribe((event: TranslationChangeEvent) => {

    });

    translate.setDefaultLang('he');
    translate.use('he');

    // this.restApiService.service('users').create({ usr_email: 'admin', usr_password : '1234' })
    console.log('app.component going to initiate initFlutterBroadcast');
  }

  snavOpenedChange(e) {
    if (this.mobileQuery.matches){
      this.appStateService.sideMenuIsOpen.next(e);
    }
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  logout() {
    this.appStateService.logout();
  }

  stopCampaign() {
    this.actionService.create({
      cmd: 'clear-send-queue'
    })
  }
}
